import { tw } from '@/utils/tw';

const InputCaption = tw.theme({
  base: ['text-body-xs', 'text-gray-900', 'transition-colors', 'group-data-[status=error]:text-error-600'],
});

export default InputCaption;
